export function handlePreviewLinkClick(e) {
  const link = e.target.closest('a[href]');
  if (link) {
    e.preventDefault();
    window.open(link.href, '_blank', 'noreferrer');
  }
}
